export enum ShownResult {
  NONE,
  SIMULATION,
  SEARCH,
  ATTACK,
}
